export default __webpack_public_path__ + "static/media/class_xi_xii_medical_tab.21946982.png";